export interface RouteModel {
    title: string;
    path: string;
    step: number;
    btnLabel?: string;
}

export const homeRoute = {
    step: -1,
    title: '',
    path: '/forfaits-mobiles/sans-engagement',
};
export const phoneRoute = {
    step: 0,
    title: 'Téléphones',
    path: '/forfaits-mobiles/sans-engagement/telephone',
};
export const optionRoute = {
    step: 0.1,
    title: 'Options',
    path: '/forfaits-mobiles/sans-engagement/options',
};
export const panierRoute = {
    step: 1,
    title: 'Panier',
    path: '/forfaits-mobiles/sans-engagement/panier',
};
export const rioRoute = {
    step: 2,
    title: 'Numéro de téléphone',
    path: '/forfaits-mobiles/sans-engagement/conservation-de-votre-numero',
};
export const contactDetailRoute = {
    step: 3,
    title: 'Coordonnées',
    path: '/forfaits-mobiles/sans-engagement/coordonnees',
};
export const facturationRoute = {
    step: 3.5,
    title: 'Facturation',
    path: '/forfaits-mobiles/sans-engagement/facturation',
};
export const livraisonRoute = {
    step: 4,
    title: 'Livraison',
    path: '/forfaits-mobiles/sans-engagement/livraison',
};
export const paiementRoute = {
    step: 5,
    title: 'Paiement',
    path: '/forfaits-mobiles/sans-engagement/paiement',
    btnLabel: 'Effectuer votre règlement',
};
export const merciRoute = {
    step: 6,
    title: 'Merci',
    path: '/forfaits-mobiles/sans-engagement/merci',
};
export const merciRedirectionRoute = {
    step: 7,
    title: 'Merci',
    path: '/forfaits-mobiles/sans-engagement/merci-redirection',
};
export const notFoundRoute = {
    title: '404',
    path: '/forfaits-mobiles/sans-engagement/404',
};
export const stepsRoutes: Array<RouteModel> = [
    phoneRoute,
    optionRoute,
    panierRoute,
    rioRoute,
    contactDetailRoute,
    facturationRoute,
    livraisonRoute,
    paiementRoute,
];

const appRoutes: Array<RouteModel> = [
    {
        title: 'B&you',
        path: '/',
        step: 0,
    },
    ...stepsRoutes,
    merciRoute,
];

export default appRoutes;

export function getStepAfterContactDetail(isProBillingRequired?: boolean): string {
    return isProBillingRequired === false ? livraisonRoute.path : facturationRoute.path;
}
